// Dashboard.js
import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import api from "../Api/Api";
import Swal from "sweetalert2";

function Dashboard() {
  const [stats, setStats] = useState({
    total_drivers: 0,
    total_riders: 0,
    total_rides: 0,
    daily_earnings: 0,
    weekly_earnings: 0,
    monthly_earnings: 0,
    yearly_earnings: 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await api.get("/dashboard_stats/");
        setStats(res.data);
      } catch (error) {
        await Swal.fire({
          title: "Error",
          text: "Error fetching dashboard stats",
          icon: "error",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return (
      <Layout title="Dashboard">
        <p className="text-center py-10 text-gray-500">Loading dashboard...</p>
      </Layout>
    );
  }

  // Prepare chart data
  const chartData = [
    { name: "Daily", earnings: stats.daily_earnings },
    { name: "Weekly", earnings: stats.weekly_earnings },
    { name: "Monthly", earnings: stats.monthly_earnings },
    { name: "Yearly", earnings: stats.yearly_earnings },
  ];

  return (
    <Layout title="Dashboard">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Total Drivers</h2>
          <p className="text-2xl font-bold text-blue-600">{stats.total_drivers}</p>
        </div>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Total Riders</h2>
          <p className="text-2xl font-bold text-green-600">{stats.total_riders}</p>
        </div>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Total Rides</h2>
          <p className="text-2xl font-bold text-purple-600">{stats.total_rides}</p>
        </div>
      </div>

      {/* Earnings Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-6">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Daily Earnings</h2>
          <p className="text-xl font-bold text-indigo-600">Ksh {stats.daily_earnings}</p>
        </div>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Weekly Earnings</h2>
          <p className="text-xl font-bold text-indigo-600">Ksh {stats.weekly_earnings}</p>
        </div>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Monthly Earnings</h2>
          <p className="text-xl font-bold text-indigo-600">Ksh {stats.monthly_earnings}</p>
        </div>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Yearly Earnings</h2>
          <p className="text-xl font-bold text-indigo-600">Ksh {stats.yearly_earnings}</p>
        </div>
      </div>

      {/* Earnings Chart */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow mt-8">
        <h2 className="text-xl font-semibold mb-4 dark:text-gray-200">Earnings Overview</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="earnings" fill="#4F46E5" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Layout>
  );
}

export default Dashboard;
